import { createIcon } from "@chakra-ui/react";

const VideoIcon = createIcon({
  displayName: "VideoIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 7.5V16.5H14.5V7.5H4.5ZM4 6C3.44772 6 3 6.44772 3 7V17C3 17.5523 3.44772 18 4 18H15C15.5523 18 16 17.5523 16 17V7C16 6.44772 15.5523 6 15 6H4Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.25 8.38743C20.25 8.21679 20.0828 8.09629 19.9209 8.15026L15.2372 9.71151L14.7628 8.28849L19.4466 6.72723C20.5798 6.3495 21.75 7.19295 21.75 8.38743V15.6126C21.75 16.807 20.5798 17.6505 19.4466 17.2728L14.7628 15.7115L15.2372 14.2885L19.9209 15.8497C20.0828 15.9037 20.25 15.7832 20.25 15.6126V8.38743Z"
        fill="currentColor"
      />
    </>
  ),
});

export default VideoIcon;
